import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ViewLeaveManagementPage from "../../../../entities/DashboardPage/HRModule/ViewLeaveManagement";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";
import { getBlobErrorMessage } from "../../../../utils/blobError";

const ViewLeaveManagement = () => {
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { item } = state || {};
  const [leave, setLeave] = useState();
  
  const handleRequest = async (id, status, isPaid) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleLeaveRequest(id, status, isPaid);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        navigate("/dashboard/leaveManagement")
        showAlert(result?.message, "success");
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  }
  const getLeave = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getEmpLeave(item?.employee?._id);
      if (result?.success) {
        setLeave(result?.data);
        LoaderHelper.loaderStatus(false);

      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };


  const getLeavePdf = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getLeavePdf(item?._id);
      if (!result || result?.success === false) {
        showAlert(result?.message || "Unable to download leave PDF.", "error");
        return;
      }
      const downloadError = await getBlobErrorMessage(result);
      if (downloadError) {
        LoaderHelper.loaderStatus(false);
        showAlert(downloadError, "error");
        return;
      }
      const blob = new Blob([result], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const fileName = item?.employee?.stafId
        ? `leave-${item.employee.stafId}.pdf`
        : `leave-request.pdf`;
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      showAlert(error?.message || "Unable to download leave PDF.", "error");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  useEffect(() => {
    if (item?.employee?._id) {
      getLeave();
    }
  }, [item?.employee?._id]);

  const handleDownload = () => {
    getLeavePdf();
  };

  return (
    <>
      <ViewLeaveManagementPage item={item} handleRequest={handleRequest} leave={leave} handleDownload={handleDownload} />
    </>
  )

}

export default ViewLeaveManagement;
